import { Injectable } from '@angular/core';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { Action } from '@ngrx/store/src/models';
import { RequestAccessService } from '../../services/request-access/request-access.service';
import {
  RequestAccessActionTypes,
  RequestAccessSuccessAction,
  RequestAccessErrorAction
} from '../../actions/request-access/request-access.actions';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

@Injectable()
export class RequestAccessEffects {
  @Effect()
  public requestAccess(): Observable<Action> {
    return this.actions.pipe(
      ofType(RequestAccessActionTypes.REQUEST),
      exhaustMap((action: any) => {
        return this.requestAccessService.requestAccess(action.requestor).pipe(
          map(response => {
            if (!response.success) {
              return RequestAccessErrorAction({
                error: new Error(response.message)
              });
            }

            return RequestAccessSuccessAction({
              response: <ApiResponseSimple>response
            });
          }),
          catchError(error => of(RequestAccessErrorAction({ error })))
        );
      })
    );
  }

  constructor(private actions: Actions, private requestAccessService: RequestAccessService) {}
}
